import { Reveal, SectionHeading } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function WhatYouSee() {
  const { t } = useLanguage();
  const ITEMS = [
    { key: "s1", img: "/assets/see-match.webp", alt: "赛事互动视觉" },
    { key: "s2", img: "/assets/see-esports.webp", alt: "数字竞技视觉" },
    { key: "s3", img: "/assets/see-classic.webp", alt: "经典娱乐视觉" },
    { key: "s4", img: "/assets/see-news.webp", alt: "最新资讯视觉" },
  ];
  return (
    <section data-testid="what-you-see-section" className="py-4">
      <div className="px-6">
        <SectionHeading index="02" eyebrow="Content" title={t("seeHeading")} testId="what-you-see-heading" />
        <p className="-mt-3 mb-4 text-[12px] leading-relaxed text-slate-400" data-testid="what-you-see-sub">
          {t("seeSub")}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 px-6 pb-1 sm:grid-cols-4" data-testid="what-you-see-grid">
        {ITEMS.map((item, i) => (
          <Reveal key={item.key} delay={i * 0.05}>
            <article
              data-testid={`what-you-see-item-${i + 1}`}
              className="h-full overflow-hidden rounded-2xl border border-[rgba(22,99,230,0.12)] bg-white shadow-[0_10px_28px_-16px_rgba(11,61,145,0.3)] transition-transform duration-300 hover:-translate-y-0.5"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                />
              </div>
              <div className="px-3 py-2.5">
                <h3 className="text-[13px] font-semibold text-[#0F1E3D]">{t(`${item.key}Title`)}</h3>
                <p className="mt-0.5 text-[11px] leading-relaxed text-slate-500">{t(`${item.key}Desc`)}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
